import dayjs from 'dayjs'

import { MissionCardProps } from './MissionCard'
import styles from './QAMissionCard.module.scss'
interface Props {
  missionCard: MissionCardProps
}
const QAMissionCard = ({ missionCard }: Props) => {
  const handleClick = (id: string) => {
    const options = 'top=10, left=10, width=500, height=600, status=no, menubar=no, toolbar=no, resizable=no'

    window.open('/my/review/' + id, '리뷰', options)
  }

  const isStamGroupMission = !!missionCard.stampGroups?.[0]?.name

  if (!isStamGroupMission) {
    return (
      <>
        <span>스탬프: {missionCard.stampGroups.length}개</span>
        <table className={styles.qacard}>
          <thead>
            <tr>
              <th className={styles.index}> - </th>
              <th>리뷰 </th>
              <th>스탬프 생성시간</th>
            </tr>
          </thead>
          <tbody>
            {missionCard.stampGroups.map((stampGroup, index) => {
              const stamp = stampGroup.stamps[0]

              return (
                <tr key={index}>
                  <td className={styles.index}>{index + 1}</td>
                  <td style={{ cursor: 'pointer' }} onClick={() => handleClick(stamp?.proof.id ?? '')}>
                    {stamp?.proof.id}
                  </td>
                  <td>{dayjs(stamp.createdDateTime).format('YYYY.MM.DD hh:mm:ss')}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </>
    )
  }

  return (
    <>
      {missionCard.stampGroups.map(stampGroup => {
        return (
          <>
            <h4>{stampGroup.name}</h4>
            <span>스탬프: {stampGroup.stamps.length}개</span>
            <table className={styles.qacard}>
              <thead>
                <tr>
                  <th className={styles.index}> - </th>
                  <th>리뷰 </th>
                  <th>스탬프 생성시간</th>
                </tr>
              </thead>
              <tbody>
                {stampGroup.stamps.map((stamp, index) => {
                  return (
                    <tr key={index}>
                      <td className={styles.index}>{index + 1}</td>
                      <td style={{ cursor: 'pointer' }} onClick={() => handleClick(stamp?.proof.id ?? '')}>
                        {stamp?.proof.id}
                      </td>
                      <td>{dayjs(stamp.createdDateTime).format('YYYY.MM.DD hh:mm:ss')}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </>
        )
      })}
    </>
  )
}

export default QAMissionCard
